<nav id=topnav class= "navbar topnavbar topwidth navbar-expand-lg navbar-light" role="navigation">
    <div class=" p-0" style="    display: flex;
    justify-content: space-between;
    width: 95%;">
        
          <div class="set-margin page-title">
            <h1 class="font-28 mt-2 gary-t font600 mb-0 l-h40 pl-3 pt-3" style="padding-top: 0px"> {{headerTitle}}</h1>
        </div>
        <div class="collapse navbar-collapse" [ngClass]="{ 'show': isShown }" id="navbarTogglerDemo03">
            <ul class="navbar-nav  ml-auto"> 
                <div class="container-fluid  p-0 in">
                    <div id="navigation" class="active"> 
                        <div class="clearfix"></div>
                    </div> 
                </div>
            </ul>

        </div>
    </div>
</nav>